import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/OutstandingGoodsReceiveNoteReport/APReportOutstandingGoodsReceiveNoteAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class APReportOutstandingGoodsReceiveNoteActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/OutstandingGoodsReceiveNoteReport/APReportOutstandingGoodsReceiveNote")
	}

	render() {
		return (
			<Activity 
				name="APReportOutstandingGoodsReceiveNote"
				RenderedComponent={this.RenderedComponent}
				context="APReportOutstandingGoodsReceiveNote"
				action="APReportOutstandingGoodsReceiveNote"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(APReportOutstandingGoodsReceiveNoteActivity)
